import React, { memo, useCallback } from 'react';
import { colorPalette } from 'ui/theme';
import { CurrencyTitleBarProps } from './types';
import { PermissionType } from 'services/permissions';
import FBOTitleBar from 'ui/theme/components/FBOTitleBar/FBOTitleBar';
import FBOButton from 'ui/theme/components/FBOButton/FBOButton';
const CurrencyTitleBar: React.FC<CurrencyTitleBarProps> = (props) => {
  const {
    activeCurrency,
    onSave,
    onClose,
    onUndeleteClicked,
    deleteModalVisible,
  } = props;

  const DeletedCurrencyActionsRestyle = useCallback(() => {
    return (
      <>
        <FBOButton
          variant="secondary"
          color="positive"
          size="medium"
          data-qa="curreny-undelete"
          onClick={() => onUndeleteClicked(false)}
          permissions={[PermissionType.CurrencyDelete]}
        >
          Undelete
        </FBOButton>
        <FBOButton
          variant="secondary"
          color="positive"
          size="medium"
          data-qa="curreny-undelete-and-close"
          onClick={() => onUndeleteClicked(true)}
          permissions={[PermissionType.CurrencyDelete]}
        >
          Undelete And Close
        </FBOButton>
      </>
    );
  }, [onUndeleteClicked]);

  const CurrencyActionsRestyle = useCallback(() => {
    return (
      <>
        {activeCurrency.id && activeCurrency.id > 0 && (
          <FBOButton
            sx={{ marginRight: '8px' }}
            variant="secondary"
            color="negative"
            size="medium"
            icon="TrashCan"
            data-qa="currency-title-bar-delete"
            onClick={() => deleteModalVisible(true)}
            permissions={[PermissionType.CurrencyDelete]}
          >
            Delete
          </FBOButton>
        )}
        <FBOButton
          sx={{ marginRight: '8px' }}
          variant="secondary"
          color="positive"
          size="medium"
          data-qa="currency-title-bar-save"
          onClick={() => onSave(false)}
          permissions={
            activeCurrency.id && activeCurrency.id > 0
              ? [PermissionType.CurrencyEdit]
              : [PermissionType.CurrencyCreate]
          }
        >
          Save
        </FBOButton>
        <FBOButton
          sx={{ marginRight: '8px' }}
          variant="secondary"
          color="positive"
          size="medium"
          data-qa="currency-title-bar-save-and-close"
          onClick={async () => {
            await onSave(true);
            onClose();
          }}
          permissions={
            activeCurrency.id && activeCurrency.id > 0
              ? [PermissionType.CurrencyEdit]
              : [PermissionType.CurrencyCreate]
          }
        >
          Save And Close
        </FBOButton>
      </>
    );
  }, [activeCurrency.id, deleteModalVisible, onSave]);

  return (
    <FBOTitleBar
      title={`${activeCurrency.name || 'New Currency'}`}
      sx={{
        borderBottom: `1px solid ${colorPalette.redesign.background3}`,
      }}
    >
      {activeCurrency.deleted ? (
        <DeletedCurrencyActionsRestyle />
      ) : (
        <CurrencyActionsRestyle />
      )}
      <FBOButton
        variant="tertiary"
        color="neutral"
        size="medium"
        icon="FBOClose"
        data-qa="currency-close-button"
        onClick={onClose}
      />
    </FBOTitleBar>
  );
};

export default memo(CurrencyTitleBar);
